import React from 'react';
import { motion } from 'framer-motion';
export function PageTransition({
  children
}: {
  children: React.ReactNode;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 15
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} data-id="element-156">
      {children}
    </motion.div>;
}